import _styled from "styled-components";
const _excluded = ["open", "width", "openRight", "onResize", "children", "resizeAffordance", "minWidth", "maxWidth", "closedWidth", "style"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import styledC from 'styled-components';
import theme from '@adsk/alloy-react-theme';
import useResizePanel from './useResizePanel';
import Panel from '../../Panel';
import { ResizeDivider } from '../../ResizeDivider';
const StyledPanel = styledC(Panel).withConfig({
  displayName: "ResizePanel__StyledPanel",
  componentId: "sc-he4hhw-0"
})(["border-right:1px solid ", ";box-shadow:", ";max-width:100%;min-width:", ";"], theme.colors.charcoal100, props => props.minWidth !== undefined ? "0 0 0 1px ".concat(theme.colors.charcoal200) : undefined, props => props.minWidth !== undefined ? "".concat(props.minWidth, "px") : undefined);
var _StyledStyledPanel = styledC(StyledPanel).withConfig({
  displayName: "ResizePanel___StyledStyledPanel",
  componentId: "sc-he4hhw-1"
})(["", ""], p => p.$_css);
const StyledDiv = styledC.div.withConfig({
  displayName: "ResizePanel__StyledDiv",
  componentId: "sc-he4hhw-2"
})(["padding:0;display:flex;position:relative;max-width:100%;"]);
const ResizePanel = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      open,
      width,
      openRight,
      onResize,
      children,
      resizeAffordance = 16,
      minWidth,
      maxWidth,
      closedWidth,
      style
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    getResizeDividerProps,
    getPanelProps
  } = useResizePanel({
    width,
    minWidth,
    maxWidth,
    openRight,
    onResize,
    open,
    resizeAffordance
  });
  return /*#__PURE__*/React.createElement(StyledDiv, null, open && /*#__PURE__*/React.createElement(ResizeDivider, getResizeDividerProps()), /*#__PURE__*/React.createElement(_StyledStyledPanel, _extends({
    ref: ref
  }, getPanelProps(props), {
    $_css: style
  }), children));
});
ResizePanel.displayName = 'ResizePanel';
ResizePanel.propTypes = {
  /** If panel is open or not */
  open: PropTypes.bool,
  /** If panel is opens to the right or not */
  openRight: PropTypes.bool,
  /** Panel content */
  children: PropTypes.any,
  /** Width of Panel.  Use Panel.WIDTHS for standard widths */
  width: PropTypes.number,
  /** Width of Resize Affordance */
  resizeAffordance: PropTypes.number,
  /** Called whenever the panel resizes */
  onResize: PropTypes.func,
  /** Minimum width allowed by resize */
  minWidth: PropTypes.number,
  /** Maximum width allowed by resize */
  maxWidth: PropTypes.number,
  /** If panel is closed it will retain this size */
  closedWidth: PropTypes.number
};
export default ResizePanel;
//# sourceMappingURL=ResizePanel.js.map